var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2331 3.62061C15.5742 3.62061 15.0471 4.15345 15.0471 4.8066C15.0471 5.45976 15.58 5.9926 16.2331 5.9926C16.8863 5.9926 17.4191 5.45976 17.4191 4.8066C17.4191 4.15345 16.8863 3.62061 16.2331 3.62061Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9506 5.14526C8.20042 5.14526 5.96021 7.38548 5.96021 10.1356C5.96021 12.8858 8.20042 15.126 10.9506 15.126C13.7007 15.126 15.9409 12.8858 15.9409 10.1356C15.9409 7.38548 13.7007 5.14526 10.9506 5.14526ZM10.9506 13.3327C9.18589 13.3327 7.75352 11.9003 7.75352 10.1356C7.75352 8.37095 9.18589 6.93858 10.9506 6.93858C12.7152 6.93858 14.1476 8.37095 14.1476 10.1356C14.1476 11.9003 12.7152 13.3327 10.9506 13.3327Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9154 20.2708H6.81967C3.4622 20.2708 0.729248 17.5379 0.729248 14.1804V6.09042C0.729248 2.73295 3.4622 0 6.81967 0H14.9154C18.2729 0 21.0001 2.73295 21.0001 6.09042V14.1861C21.0001 17.5436 18.2671 20.2766 14.9097 20.2766L14.9154 20.2708ZM6.81967 1.90791C4.51642 1.90791 2.63716 3.78144 2.63716 6.09042V14.1861C2.63716 16.4894 4.51069 18.3686 6.81967 18.3686H14.9154C17.2186 18.3686 19.0979 16.4951 19.0979 14.1861V6.09042C19.0979 3.78717 17.2244 1.90791 14.9154 1.90791H6.81967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite);
export default __webpack_public_path__ + "static/media/instagram-white.c8ce3a464660d1154391fabc32402ce5.svg";
export { ForwardRef as ReactComponent };